import type { QueryClient } from "@tanstack/react-query";

import { QUERY_KEYS } from "@config/constant";

/**
 * Single-flight `resetQueries` for notify infinite list (all `useChatNotificationBell`
 * instances share one in-flight promise so opening /chat does not N× the network).
 */
let notifyBellListResync: Promise<void> | null = null;

export function awaitNotifyBellListResync(
  queryClient: QueryClient,
): Promise<void> {
  if (!notifyBellListResync) {
    notifyBellListResync = queryClient
      .resetQueries({
        queryKey: [QUERY_KEYS.NOTIFY_MESSAGE_INFINITE],
        exact: false,
      })
      .then(() => undefined)
      .finally(() => {
        notifyBellListResync = null;
      });
  }
  return notifyBellListResync;
}
